<template>
	<div id="group">
		<div class="container">
			<div class="float-left">
				<div class="width300">
					<div class=" float-left"><img style="border-radius:50%" :src="picture" width="100" height="100"></div>
					<div class=" float-left g-tit">
						<h3>{{username}}</h3>
						<h4>认证状态:<Icon type="logo-vimeo" /><span @click='authen' class='authen'>{{card}}</span></h4>
					</div>
					<div class=" clearfix"></div>
					<div class="g-sf">
						所属身份 | {{identity}}
					</div>
					<div class="g-edit-btn">
						<router-link to='/group_admin/edit/ypxx'>发布招募信息</router-link>
					</div>

				</div>
				<div class="g-left-middle width300 ">
					<router-link to='/group_admin/release'>
						<p>我的发布</p>
					</router-link>
					<router-link to='/group_admin/received/email'>
						<p>我的收件</p>
					</router-link>
					<router-link to='/group_admin/change/changeinfo'>
						<p>修改信息</p>
					</router-link>
					<router-link to='/group_admin/collect/jzcollect'>
						<p>我的收藏</p>
					</router-link>
					<router-link to='/group_admin/authen'>
						<p>在线认证</p>
					</router-link>
					<router-link to='/group_admin/bind'>
						<p>绑定账号</p>
					</router-link>
					<router-link to='/group_admin/feedback'>
						<p>意见反馈</p>
					</router-link>
				</div>
				<div class="g-left-bottom width300">
					<div class="g-sf">
						zuikanyusheng@126.com
					</div>
					<div class="g-edit-btn">联系我们</div>
				</div>
			</div>
			<div class="float-right">

				<router-view></router-view>
			</div>
			<div class=" clearfix"></div>



		</div>
	</div>
</template>

<script>
	
	import storage from '../../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				username: storage.get('username'),
				picture:storage.get('picture'),
				identity: '',
				card:''
				
			}
		},
		methods:{
			authen(){
				this.$router.push('/group_admin/authen')
			},
			
		},
		mounted() {
			var token=storage.get('token')
			if(token==null){
				this.$router.push('/')
			}
			var iden = storage.get('iden')
			if (iden == '2') {
				var identity = '剧组'
				this.identity = identity
			}
			
			//认证信息判断
			var card=storage.get('card')
			if(card=='1'){
				this.card='未认证'
				$(function(){
					$('.ivu-icon-logo-vimeo').css('color',"grey");
				})
			}
			if(card=='2'){
				this.card='审核中'
				$(function(){
					$('.authen').attr('disabled',"true");//jq方法禁用认证弹窗
					$('.ivu-icon-logo-vimeo').css('color',"#ff5a61");
				})
			}
			if(card=='3'){
				this.card='已认证'
				$(function(){
					$('.authen').attr('disabled',"true");//jq方法禁用认证弹窗
					$('.ivu-icon-logo-vimeo').css('color',"#c8b9a6");
				})
			}
			


		}

	}
</script>
<style scoped>
	.authen:hover{
		color: #333!important;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/group_admin/Group.vue